/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbSpinnerModule,
} from '@nebular/theme';

import { NbPasswordAuthStrategy, NbAuthModule, NbAuthJWTToken } from '@nebular/auth';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthGuard } from './guards/auth-guard.service';
import { HttpInterceptorModule } from './interceptors/http.interceptor.module';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { environment } from '../environments/environment';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';
import Bugsnag from '@bugsnag/js';
import { GuidedTourModule } from 'ngx-guided-tour';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { NgxMaskModule } from 'ngx-mask';

Bugsnag.start({
  apiKey: environment.BUGSNAG_API_KEY,
  appType: environment.BUGSNAG_APP_TYPE,
  appVersion: environment.BUGSNAG_APP_VERSION,
  releaseStage: environment.BUGSNAG_APP_RELEASE_STAGE,
  enabledReleaseStages: ['Dev', 'Staging', 'Production']
});

export function bugsnagErrorHandlerFactory() {
  return new BugsnagErrorHandler();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot({
      icon: '',
      preventDuplicates: true
    }),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    NbSpinnerModule,
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    ReactiveFormsModule,
    HttpInterceptorModule,
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email',
          token: {
            class: NbAuthJWTToken,
            key: 'data.token',
          },
          baseEndpoint: environment.CMO_API_URL,
          login: {
            // ...
            // redirect: {
            //   success: '/pages/stores/list',
            //   failure: null, // stay on the same page
            // },
            endpoint: 'login',
            method: 'post',
          },
        }),
      ],
      forms: {
        login: {
          // delay before redirect after a successful login, while success message is shown to the user
          redirectDelay: 500,
          strategy: 'email',  // strategy id key.
          remember_me: false,   // whether to show or not the `rememberMe` checkbox
          showMessages: {     // show/not show success/error messages
            success: true,
            error: true,
          },
        },
      },
    }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireMessagingModule,
    GuidedTourModule.forRoot(),
    RecaptchaV3Module,
    NgxMaskModule.forRoot(),
  ],
  providers: [
    AuthGuard,
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.RECAPTCHA_SITE_KEY },
    { provide: ErrorHandler, useFactory: bugsnagErrorHandlerFactory },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
